import { Star } from "lucide-react";

export function StarRating({ rating, size = "md", showValue = true }) {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
  };

  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;

  for (let i = 0; i < 5; i++) {
    if (i < fullStars) {
      stars.push(
        <Star
          key={i}
          className={`${sizeClasses[size]} fill-gold-bright text-gold-bright`}
        />
      );
    } else if (i === fullStars && hasHalfStar) {
      stars.push(
        <div key={i} className="relative">
          <Star className={`${sizeClasses[size]} text-slate-300`} />
          <div className="absolute inset-0 overflow-hidden w-1/2">
            <Star className={`${sizeClasses[size]} fill-gold-bright text-gold-bright`} />
          </div>
        </div>
      );
    } else {
      stars.push(
        <Star key={i} className={`${sizeClasses[size]} text-slate-300`} />
      );
    }
  }

  return (
    <div className="flex items-center gap-1">
      <div className="flex">{stars}</div>
      {showValue && (
        <span className="ml-1 font-semibold text-navy">{rating.toFixed(1)}</span>
      )}
    </div>
  );
}

export function StarRatingInput({ value, onChange, size = "lg" }) {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-10 h-10",
  };

  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => onChange(star)}
          className="transition-transform hover:scale-110 focus:outline-none"
          data-testid={`star-input-${star}`}
        >
          <Star
            className={`${sizeClasses[size]} ${
              star <= value
                ? "fill-gold-bright text-gold-bright"
                : "text-slate-300 hover:text-gold"
            }`}
          />
        </button>
      ))}
    </div>
  );
}
